import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { User } from "firebase/auth";
import { UserPayload } from "../interfaces";

@Injectable({ providedIn: "root" })
export class UserService {
  private user$: BehaviorSubject<User>;
  private user: User = <User>{};
  private token: string = "";

  constructor() {
    this.user$ = new BehaviorSubject(this.user);
  }

  getUser$() {
    return this.user$.asObservable();
  }

  getUser() {
    return this.user;
  }

  setUser$(user: User) {
    this.user$.next(user);
  }

  setUser(user: User) {
    this.user = user;
  }

  getToken() {
    return this.token;
  }

  setToken(token: string) {
    this.token = token;
  }

  getUserPayload(user: User): UserPayload {
    const userPayload: UserPayload = {
      userId: user.uid,
      emailVerified: user.emailVerified,
    }
    if (user.email) {
      userPayload.email = user.email
    }
    if (user.phoneNumber) {
      userPayload.contactNumber = user.phoneNumber
    }
    if (user.photoURL) {
      userPayload.avatarURL = user.photoURL;
    }
    if (user.displayName) {
      userPayload.displayName = user.displayName;
    }
    return userPayload;
  }
}
